import { render, staticRenderFns } from "./MisCreditos.vue?vue&type=template&id=fe972ae2&"
import script from "./MisCreditos.vue?vue&type=script&lang=js&"
export * from "./MisCreditos.vue?vue&type=script&lang=js&"
import style0 from "./MisCreditos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports